export default __webpack_public_path__ + "static/media/IMG_9672.29ae0fee.jpeg";